import React from 'react'
import { connect } from 'react-redux'
import upperFirst from 'lodash/upperFirst'
import { Button } from 'reactstrap'
import { BsrsGrid, DropDownFilterCell, IN_EDIT } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { processResx, prepareDataForGroupEnumFilter } from './Resources.DataSource'
import { actionCreators } from '@/store/Resources'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'

import { MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'

export class Resources extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      data: []
    }
  }

  static getDerivedStateFromProps (props, state) {
    if (props.resources.fetched === true && state.data && state.data.length === 0) {
      return { data: processResx(props.resources.resx) }
    }

    return null
  }

  componentDidMount () {
    if (this.props.resources.fetching !== true && this.props.resources.fetched !== true) {
      this.props.loadResources()
    }
  }

  onItemEdited (editedItem) {
    let locale = 'en'
    if (editedItem.item[IN_EDIT] === 'valueAr') {
      locale = 'ar'
    }
    const resource = {
      locale,
      type: upperFirst(editedItem.item.group),
      key: upperFirst(editedItem.item.key),
      value: editedItem.value
    }
    this.props.updateResource(resource)
  }

  render () {
    const isReloadEnabled = this.props.localization.clearingCache !== true
    const groupFilterEnumData = prepareDataForGroupEnumFilter(this.props.resources.resx)
    const { localize } = this.props
    const defaultCategoryFilterItem = { value: -1, text: localize('Common.SelectValue') }
    return (
      <div className='main'>
        <MainTop>
          <MainTopTitle>
            <Resx name='Common.Resources' />
          </MainTopTitle>
          <MainTopLeft>
            <Button color='primary'
              className='reload-button btn-sm'
              disabled={!isReloadEnabled}
              onClick={() => this.props.reloadResources()}>
              <Icon name='revision' /> <span>
                <Resx name='Common.RefreshResources' /></span></Button>
          </MainTopLeft>
        </MainTop>
        <MainBody>
          <BsrsGrid
            persistenceId={'resources-administration'}
            className=''
            items={this.state.data}
            exitEditingOnEnter
            editable
            onItemEdited={(editedItem) => this.onItemEdited(editedItem)}>

            <Column field='group' title={localize('Common.Group')} width='250px' editable={false} filterCell={DropDownFilterCell(groupFilterEnumData, { dataItemKey: 'value', textField: 'text', defaultItem: defaultCategoryFilterItem })} />
            <Column field='key' title={localize('Common.Key')} editable={false} />
            <Column field='valueEn' title={localize('Common.ValueEn')} editor='text' editable />
            <Column field='valueAr' title={localize('Common.ValueAr')} editor='text' editable />
          </BsrsGrid>
        </MainBody>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    localization: state.localization,
    resources: state.resources,
    localize: (key) => state.localization.data[key] || `[${key}]`,
    ...ownProps
  }
}

const mapDispatchToProps = {
  loadResources: actionCreators.loadResourcesForAllLocales,
  updateResource: actionCreators.updateResource,
  reloadResources: actionCreators.reload
}

export default connect(mapStateToProps, mapDispatchToProps)(Resources)



// WEBPACK FOOTER //
// ./src/internal-app/components/administration/resources/Resources.js